<template lang="html">
  <div class="placed-backg faqs-page" id="page-info-t1">
    <div class="bg-image"></div>

    <section class="container oversized-container content-section">
      <div class="row align-items-start justify-content-center" v-bind:class="{ 'tabla-page' : $route.params.table == 'tabla' }">

        <div class="col-12 col-title-s1">
          <h3 class="title">Preguntas frecuentes</h3>
        </div>

        <div class="col-lg-10 col-info" id="faqs-box">
          <p>
            Si tienes alguna duda consulta las preguntas frecuentes. Si no se resuelve tu duda, no dudes en contactarnos.
          </p>

          <br />
          <h5 class="subtitle-sm">¿Cuál es la cobertura de BlackFon?</h5>
          <p>
            Contamos con cobertura en todo el país puedes consultarlo <router-link target="_blank" to="/cobertura">aquí</router-link>.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Qué pasa si se me acaban mis datos?</h5>
          <p>
            No te preocupes puedes realizar una recarga nuevamente desde aquí. Link para recargas.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Mis datos se acumulan para el siguiente mes?</h5>
          <p>
            No amigo, todos nuestros planes tienen una vigencia Estelar, Bigbang, Infinity, Star y Sol son de 30 días el Cometa de 3 días, Space de 7 días y Universe de 15 días.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Puedo cambiar de plan?</h5>
          <p>
            Claro que si, al momento de hacer nuevamente una recarga puedes elegir el plan que más te agrade.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Qué planes puedo adquirir con BlackFon?</h5>
          <p>
            Contamos con varios servicios para que elijas el que mejor se adapte a tus necesidades consúltalos <router-link target="_blank" to="/paquetes/movilidad">aquí</router-link>.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Qué día me entregarán mi sim?</h5>
          <p>
            Esto es en caso de que vendamos el sim desde nuestra página.
          </p>

          <h5 class="mt-2 subtitle-sm">¿En dónde puedo recoger mi tarjeta sim si me cambie con ustedes por su página?</h5>
          <p>
            En cualquiera de nuestras sucursales y ahí mismo puedes realizar tus recargas y aclarar cualquier duda.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Me puedo cambiar con mi mismo número?</h5>
          <p>
            Claro solo hay que hacer un proceso de portabilidad (cambio de compañía)
          </p>

          <h5 class="mt-2 subtitle-sm">¿En qué tiempo tendré mí mismo número?</h5>
          <p>
            El IFT (Instituto Federal de Telecomunicaciones) garantiza un cambio de compañía libre y gratuito en 24 Horas en días hábiles.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Cuánto tiempo me quedo sin servicio si me cambio con ustedes?</h5>
          <p>
            No te quedes sin servicio, en el momento que tu número quede inactivo en la otra compañía, en automático estará activo en tu nuevo sim BlackFon.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Puedo cancelar o cómo Cancelo?</h5>
          <p>
            Nosotros no manejamos planes con plazo forzoso, en cualquier momento te puedes comunicar con uno de nuestros ejecutivos para que te ayuden a cancelar tu servicio.
          </p>

          <h5 class="mt-2 subtitle-sm">¿Mi teléfono es compatible con BlackFon?</h5>
          <p>
            La mayoría de equipos son compatibles para cerciorarte acude a nuestras tiendas o visita nuestra página de internet www.blackfon.online, también puedes consultarlo en nuestro teléfono de atención a clientes al 0000000
          </p>

          <h5 class="mt-2 subtitle-sm">¿Qué ajustes tiene que tener mi teléfono para que funcione lo mejor posible en su compañía?</h5>
          <p>
            Solo hay que tener la opción de roaming siempre activa y encendido siempre el servicio de VoLTE desde los ajustes de tu Smartphone en el caso de no tenerlo descarga desde play store la aplicación voz app.
          </p>

          <!-- <h5 class="mt-2 subtitle-sm">¿Puedo hacer recargas vía telefónica en su número de atención a clientes?</h5>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor in.
          </p> -->
        </div>

      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{    }
  }
}
</script>
